var _path, _path2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlarm = function SvgAlarm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256,476c106.816,0,193.712-87.552,193.712-195.152S362.816,85.68,256,85.68 S62.288,173.232,62.288,280.848S149.2,476,256,476z M244,141.328h24v142.784l90.32,90.992l-17.024,16.912L244.016,294V141.328H244z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED1C24"
    },
    d: "M167.312,38.224V12C92.864,36.992,32.288,92.544,0,163.744h27.04 C56.304,106.096,106.416,60.896,167.312,38.224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED1C24"
    },
    d: "M512,163.744C479.712,92.544,419.136,37.008,344.704,12v26.224 c60.88,22.672,110.992,67.872,140.256,125.52L512,163.744L512,163.744z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.288,280.848C38.288,401.696,135.952,500,256,500s217.712-98.32,217.712-219.152S376.048,61.68,256,61.68 S38.288,160,38.288,280.848z M256,85.68c106.816,0,193.712,87.552,193.712,195.152S362.816,476,256,476 S62.288,388.448,62.288,280.848S149.2,85.68,256,85.68z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ED1C24"
    },
    points: "358.304,375.104 268,284.128 268,141.328 244,141.328 244,294 341.28,392.016 "
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
};
export { SvgAlarm as ReactComponent };